import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {labels} from '../../../../../../util/utils';
import StyledSeeMore from './StyledSeeMore';
import Button from '../../../../../CoreWrappers/Button';

const SeeMore = (props) => {
	const {children, noOfLines, customLinkLabel, onCustomLinkHandler} = props;

	const [isExpanded, setIsExpanded] = useState(false);
	const [isEnabled, setIsEnabled] = useState(false);

	const innerTextRef = useRef(null);

	useEffect(() => {
		if (innerTextRef.current) {
			const {offsetHeight, scrollHeight} = innerTextRef.current;
			setIsEnabled(offsetHeight < scrollHeight);
		}
	}, [children]);

	const getDisplayLink = () => {
		if (customLinkLabel && onCustomLinkHandler) {
			return (
				<Button label={customLinkLabel} title={customLinkLabel} variant={'text-alt'} onClick={onCustomLinkHandler} />
			);
		} else {
			if (!isExpanded) {
				return (
					<Button
						label={labels.seeMore}
						title={labels.seeMore}
						variant={'text-alt'}
						onClick={() => {
							setIsExpanded(true);
						}}
					/>
				);
			} else {
				return (
					<Button
						label={labels.seeLess}
						title={labels.seeLess}
						variant={'text-alt'}
						onClick={() => {
							setIsExpanded(false);
						}}
					/>
				);
			}
		}
	};

	return (
		<StyledSeeMore noOfLines={noOfLines ? noOfLines : 4} isExpanded={isExpanded} className={`show-more-less`}>
			<section ref={innerTextRef} className={`richText-Body ${!isExpanded ? 'collapsed' : ''}`}>
				{children}
			</section>
			{isEnabled && <section className={'show-more-controls'}>{getDisplayLink()}</section>}
		</StyledSeeMore>
	);
};

SeeMore.propTypes = {
	children: PropTypes.element.isRequired,
	noOfLines: PropTypes.number,
	customLinkLabel: PropTypes.string,
	onCustomLinkHandler: PropTypes.func
};

export default SeeMore;
